/**
 * Webpack domyślnie ustawia publicPath na "/", więc chunki idą pod /js/… zamiast
 * do katalogu motywu. Ustawiamy go z PHP (window.themeWebpackPublicPath) przed
 * pierwszym dynamicznym import().
 */
if (typeof window.themeWebpackPublicPath === 'string' && window.themeWebpackPublicPath.length > 0) {
  // eslint-disable-next-line camelcase, no-undef
  __webpack_public_path__ = window.themeWebpackPublicPath;
}
